import { render } from "./App.vue?vue&type=template&id=3ee59970"
const script = {}

import "./App.vue?vue&type=style&index=0&id=3ee59970&lang=less"

import exportComponent from "E:\\qq\\前端(1)\\前端\\后台vue\\vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__